import { Bar, getElementAtEvent } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import Statistic from '../Statistic';

import './index.less';
import { chartOptions } from './constants';
import { Spin } from 'antd';

function ChartCard({ title, Icon, data, total, success, danger, onClickOnPoint, isSelected, 'data-testid': dataTestId, loading, styles }) {
  const chartRef = useRef(null);
  const curveTension = 0.2;

  const onClick = (event) => {
    const element = getElementAtEvent(chartRef.current, event);

    if (onClickOnPoint) {
      onClickOnPoint(element);
    }
  };

  return (
    <div data-testid={dataTestId} className={`chart-card ${isSelected ? 'selected' : ''}`}>
      {loading && (
        <div className="chart-card__loading-overlay" data-testid="chart-card--loading">
          <Spin size="large" />
        </div>
      )}
      <Statistic title={title} value={total} Icon={Icon} success={success} danger={danger} />
      <Bar
        ref={chartRef}
        options={chartOptions}
        data={{
          labels: data.labels,
          datasets: [
            {
              data: data.points,
              backgroundColor: styles?.backgroundColor,
            },
          ],
        }}
        onClick={onClick}
      />
    </div>
  );
}

ChartCard.propTypes = {
  title: PropTypes.string.isRequired,
  Icon: PropTypes.elementType.isRequired,
  data: PropTypes.object.isRequired,
  total: PropTypes.number.isRequired,
  success: PropTypes.bool,
  danger: PropTypes.bool,
  onClickOnPoint: PropTypes.func,
  isSelected: PropTypes.bool,
  loading: PropTypes.bool,
  styles: PropTypes.object,
  'data-testid': PropTypes.string,
};

ChartCard.defaultProps = {
  total: 0,
  success: false,
  danger: false,
  isSelected: false,
};

export default ChartCard;
